<template>
  <div id="indexmy">
    <div class="text-wrapper_1my flex-col">
      <div class="section_5my flex-col" :style="{backgroundImage:'url('+userInfo.wxHeaderImgUrl+')'}"></div>
      <span class="text_4my">{{ userInfo.nickname }}</span>
    </div>

    <div class="section_2my" @click="readerCard">
      <div class="text-wrapper_2my">
        <!--        <span class="text_5my">我的读者证</span>-->
        <span class="text_5my">图书馆：{{userInfo.libName}}</span>
      </div>
      <div class="section_4my justify-between">
        <span class="text_6my">读者证：{{ userInfo.readerCardNum }}</span>
      </div>
    </div>
    <div class="section_3my flex-row" @click="myread">
      <div class="image-text_2my flex-row justify-between">
        <img
          class="icon_2my"
          referrerpolicy="no-referrer"
          src="../assets/img/icon/read.svg"/>
        <span class="text-group_1my">我的阅读</span>
      </div>
      <img
        class="label_2my"
        referrerpolicy="no-referrer"
        src="../assets/img/icon/arrowgo2.svg"
      />
    </div>


    <div class="section_3my flex-row" @click="tonext">
      <div class="image-text_2my flex-row justify-between">
        <img
          class="icon_2my"
          referrerpolicy="no-referrer"
          src="../assets/img/icon/report.png"/>
        <span class="text-group_1my">年度报告</span>
      </div>
      <img
        class="label_2my"
        referrerpolicy="no-referrer"
        src="../assets/img/icon/arrowgo2.svg"
      />
    </div>

    <!-- 添加 el-dialog 组件 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      height="60%"
      @close="handleClose"
    >
      <template #title>
        <img src="../assets/img/icon/tubiao.svg" alt="icon" style="width: 40px; height: 40px; margin-right: 8px;"><span
        class="art-font">   微信读者证</span>
      </template>
      <el-row>

        <vue-qr :text="openId" :style="{height:'100%',width:'100%'}" :size="300"></vue-qr>

        <div style="padding: 14px;">
          <div class="bottom clearfix">
          </div>
        </div>
      </el-row>
      <div style="text-align: center; margin-top: 20px;">
        <el-button type="danger" @click="handleCloseOld">解绑读者证</el-button>
      </div>
    </el-dialog>

    <!-- 解绑确认弹窗 -->
    <el-dialog
      :visible.sync="unbindDialogVisible"
      width="70%"
      max-width="320px"
      center
      :append-to-body="true"
      @close="handleClose1"
    >
      <div style="font-size: 16px; text-align: center; padding: 20px 15px; line-height: 24px;">
        确定要解绑读者证吗？解绑后需要重新绑定。
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button style="min-width: 100px; height: 40px; font-size: 14px;" @click="unbindDialogVisible = false">取 消</el-button>
          <el-button style="min-width: 100px; height: 40px; font-size: 14px;" type="primary" @click="unbindCard">确 定</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import vueQr from 'vue-qr'
import $ from 'jquery'
import {gettoken, loginfirst, getAccess, getUrlVariable, getUserInfo} from '@/api2'

export default {
  name: 'My',
  data() {
    return {
      unbindDialogVisible: false,  // 解绑确认弹窗
      constants: {},
      userInfo: {},
      dialogVisible: false,
      imgUrl: '',
      // imageUrl: require("../assets/img/icon/tubiao.svg"),
      imageUrl: JSON.parse(localStorage.getItem('user')).wxHeaderImgUrl,
      openId: '',
    };
  },
  mounted() {
    document.getElementById('indexmy').style.height = document.body.clientHeight * 0.88 + 'px'
    document.getElementsByClassName('section_2my')[0].style.height = document.body.clientWidth * 0.88 * 0.331 + 'px'
    this.readerMsg()
  },
  methods: {
    unbindCard() {
      axios({
        method: 'POST',
        url: process.env.VUE_APP_BASE_URL + '/wx/unbindWxMemberCard',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        },
        data: {
          openId: JSON.parse(localStorage.getItem('user')).wxOpenId
        }
      }).then(res => {
        if (res.code === 0) {
          this.$notify({
            title: '成功',
            message: '解绑成功',
            type: 'success',
            duration: 1000
          });
          this.unbindDialogVisible = false
          this.dialogVisible = false

          // 跳转到首页并刷新
          this.$router.push({ path: 'index' }).then(() => {
            // 确保路由跳转完成后刷新页面
            window.location.reload();
          });

        } else {
          this.$message.error(res.data.msg || '未知错误')
        }
      }).catch(() => {
        this.$message.error('请求失败，请稍后再试')
      })
    },
    readerMsg() {
      this.userInfo = JSON.parse(localStorage.getItem('user'))
      // axios({
      //   method: 'POST',
      //   url: baseURL+'user/userInfo',
      //   //发送格式为json
      //   headers:
      //     {
      //       'Content-Type': 'application/json',
      //       'dataType': 'json',
      //       'Authorization': localStorage.getItem('token')
      //     }
      // }).then(response => {
      //   if (response.code === 0) {
      //     this.userInfo = response.msg
      //     // this.books = response.msg
      //   }
      // })
    },
    myread() {
      this.$router.push({
        path: 'myread'
      })
    },
    readerCard() {
      this.dialogVisible = true;
      // window.location.href = ''
      if (JSON.parse(localStorage.getItem('user')).wxOpenId === '' || JSON.parse(localStorage.getItem('user')).wxHeaderImgUrl === '') {
        const code = getUrlVariable('code')
        const state = getUrlVariable('state')
        loginfirst()
        gettoken(code, state)
        next()
      } else {
        this.imgUrl = 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png';
        this.openId = JSON.parse(localStorage.getItem('user')).wxOpenId;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose1() {
      this.unbindDialogVisible = false;
    },

    handleCloseOld() {
      this.dialogVisible = false;
      this.unbindDialogVisible = true;
    },
    tonext(){
      this.$router.push({
        path: 'yearReport',
      })
    }
    // bindreadcard(){
    //   this.$router.push({]\

    //     path: 'bind'
    //   })
    // }
  },
  components: {
    vueQr
  },
}
</script>
<style src="../assets/css/common.css"/>
<style src="../assets/css/index_my.css"/>
<style scoped>
#indexmy {
  background-image: url(../assets/img/bg.png);
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}


.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}


/* 首先，链接Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');

.art-font {
  font-family: 'Microsoft YaHei', '微软雅黑', 'sans-serif';
  font-size: 18px; /* 调整字体大小 */
  color: #191970; /* 调整字体颜色 */
  text-shadow: 2px 2px 4px #aaa; /* 添加阴影效果 */
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 15px; /* 按钮间距稍增加，优化视觉 */
  padding: 15px 20px; /* 底部区域内边距 */
}

/* 确保按钮在小屏幕上不换行 */
@media screen and (max-width: 400px) {
  .dialog-footer {
    flex-wrap: nowrap; /* 强制不换行 */
  }
  .el-button {
    flex: 1; /* 按钮均分空间 */
    min-width: 70px; /* 最小宽度，防止过窄 */
    padding: 0 10px; /* 调整内边距 */
  }
}

</style>
